module.exports = __webpack_public_path__ + "img/result-bg.svg";